import { FC, useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import Image from "@/components/Image";
import { hexToRgba } from "@/utils/theme";
import Text from "@/components/Text";
import ProductImagesModal from "./ProductImagesModal";

const ThumbOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => hexToRgba(theme.colors.black, 0.7)};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity ease-out 0.2s;
  cursor: pointer;
`;

const ThumbHolder = styled.div`
  padding: 4px;
  width: 122px;
  height: 94px;
  position: relative;
  &:hover {
    ${ThumbOverlay} {
      opacity: 1;
    }
  }
`;

export const Thumbnail = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

interface Props {
  thumbnail?: string;
  asin: string;
  productId: number;
}

const ProductThumbnail: FC<Props> = ({ thumbnail, asin, productId }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <ThumbHolder onClick={(e) => e.stopPropagation}>
        <Thumbnail src={thumbnail} />
        {!!thumbnail && (
          <>
            <ThumbOverlay
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(true);
              }}
            >
              <Text $type="smallBold" $color="white">
                Change Image
              </Text>
            </ThumbOverlay>
          </>
        )}
      </ThumbHolder>
      <AnimatePresence>
        {showModal && (
          <ProductImagesModal
            productId={productId}
            onClose={() => setShowModal(false)}
            asin={asin}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default ProductThumbnail;
